import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Typography,
  Box,
  Pagination,
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Visibility as EyeIcon,
  Print as PrintIcon,
  Delete as TrashIcon,
} from "@mui/icons-material";
import { apiUrl } from "../../comps/apiUrl";
import { toast } from "react-toastify";

class Budget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      currentPage: 1,
      totalPages: 0,
      itemsPerPage: 15,
      loader: true,
      trash: false,
    };
  }

  componentDidMount() {
    document.title = "Orçamento";
    this.fetchData(this.state.currentPage);
  }

  formatDate(dataISO) {
    if (!dataISO) return "-";
    const data = new Date(dataISO);
    return data.toLocaleString("pt-BR");
  }

  fetchData(page) {
    this.setState({ loader: true });
    fetch(
      `${apiUrl}/list-budget?page=${page}&limit=${this.state.itemsPerPage}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("token"),
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const totalItems = data.totalItems || 0;
        const totalPages = Math.ceil(totalItems / this.state.itemsPerPage);

        this.setState({
          items: data.items || [],
          currentPage: page,
          totalPages,
          loader: false,
        });
      })
      .catch(() => this.setState({ loader: false }));
  }

  handlePageChange = (event, value) => {
    this.fetchData(value);
  };

  render() {
    const { items, loader, currentPage, totalPages } = this.state;
    const invoicingType = {
      1: "Diária",
      2: "Semanal",
      3: "Quizenal",
      4: "Mensal",
      5: "Anual",
    };

    if (loader) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box sx={{ p: 3 }}>
        <Card>
          <CardHeader
            title={
              <Typography variant="h5" component="div">
                Orçamentos
              </Typography>
            }
            sx={{ backgroundColor: "#f5f5f5" }}
          />
          <Divider />
          <CardContent>
            {items.length > 0 ? (
              <TableContainer component={Paper} variant="outlined">
                <Table sx={{ minWidth: 650 }} aria-label="tabela de orçamentos">
                  <TableHead sx={{ backgroundColor: "#212529" }}>
                    <TableRow>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                        ID Cliente
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                        Nome do Cliente
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                        Faturamento
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                        Valor Locação
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                        Início
                      </TableCell>
                      <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                        Fim
                      </TableCell>
                      <TableCell
                        sx={{ color: "#fff", fontWeight: "bold" }}
                        align="center"
                      >
                        Ações
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item) => (
                      <TableRow key={item.id} hover>
                        <TableCell>{item.client_id}</TableCell>
                        <TableCell>{item.client_name}</TableCell>
                        <TableCell>{invoicingType[item.billing]}</TableCell>
                        <TableCell>
                          {(item.location_value || 0).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </TableCell>
                        <TableCell>{this.formatDate(item.start_day)}</TableCell>
                        <TableCell>{this.formatDate(item.end_day)}</TableCell>
                        <TableCell align="center">
                          <Box display="flex" justifyContent="center" gap={1}>
                            <IconButton
                              component={Link}
                              to={`/budget/view/${item.token}`}
                              color="primary"
                              size="small"
                            >
                              <EyeIcon />
                            </IconButton>
                            <IconButton
                              component={Link}
                              to={`/budget/print/${item.id}`}
                              color="info"
                              size="small"
                            >
                              <PrintIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => {
                                this.setState({ trash: item });
                              }}
                            >
                              <TrashIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant="body1" textAlign="center" sx={{ my: 4 }}>
                Não há resultados encontrados.
              </Typography>
            )}
          </CardContent>

          <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={this.handlePageChange}
              color="primary"
              shape="rounded"
              showFirstButton
              showLastButton
            />
          </Box>
        </Card>
        <Dialog
          open={Object.keys(this.state.trash).length > 0}
          onClose={() => this.setState({ trash: null })}
        >
          <DialogTitle>Excluir Orçamento</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              Tem certeza que deseja excluir do orçamento?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {}} color="">
              Cancelar
            </Button>
            <Button
              onClick={async () => {
                const id = this.state.trash.id;
                // Busque o token de onde você o armazena (ex: localStorage ou cookies)
                const token = localStorage.getItem("token");

                try {
                  // 1. Chamada ao backend usando Fetch API
                  const response = await fetch(
                    `${apiUrl}/budget/delete/${id}`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        authorization: localStorage.getItem("token"),
                      },
                    }
                  );

                  // O fetch só cai no catch em erro de rede.
                  // Erros 401, 404, 500 devem ser tratados checando !response.ok
                  if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(
                      errorData.error || "Erro ao desativar registro"
                    );
                  }

                  // 2. Se chegou aqui, o banco atualizou com sucesso. Atualizamos a UI:
                  this.setState((prevState) => ({
                    ...prevState,
                    items: prevState.items.filter((item) => item.id !== id),
                    trash: {}, // Limpa o estado do modal/lixeira
                  }));

                  toast.success("Orçamento excluido com sucesso");
                } catch (error) {
                  console.error("Erro na requisição:", error.message);
                  alert("Não foi possível excluir: " + error.message);
                }
              }}
              variant="outlined"
              color="error"
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Budget;
